<span #planMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="addPlanMenu">
  <span *ngIf="!plan"
        class="flex items-center w-fit rounded-full bg-white py-1 px-3 text-gray-500 gap-3 cursor-pointer border border-dashed border-gray-300">
        <mat-icon class="!w-4 !h-4 text-[16px] text-gray-400">add</mat-icon>
        <span class="text-xs">Add a plan</span>
  </span>
  <div *ngIf="plan"
       class="flex justify-center items-center rounded-full w-6 h-6 bg-white cursor-pointer">
    <mat-icon class="!w-4 !h-4 text-[14px] text-blue-900">border_color
    </mat-icon>
  </div>
</span>

<mat-menu #addPlanMenu="matMenu"
          class="ig-text-color-edit !rounded-md px-6 py-2">
  <div igClickStopPropagation (keydown)="onKeyDown($event)">
    <div class="flex justify-between items-center mb-5">
      <p class="text-xl font-semibold text-gray-600" igClickStopPropagation>
        {{ plan ? 'Edit Plan' : 'Add a Plan' }}
      </p>
      <mat-icon (click)="planMenuTrigger.closeMenu()"
                class="text-gray-600 text-[14px] border-[1px] border-gray-600 flex items-center justify-center !w-4 !h-4 rounded-full cursor-pointer">
        close
      </mat-icon>
    </div>

    <mat-form-field appearance="outline" igClickStopPropagation>
      <mat-label>Type</mat-label>
      <mat-select [(ngModel)]="selectedType"
                  (selectionChange)="planTypeChange($event)">
        <mat-option *ngFor="let type of planTypes"
                    [value]="type.type">{{ type.type === 'Custom' ? '-- Custom --' : type.type }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ig-field [control]="planForm.get('time')" label="Time"
              icon="scheduler" igClickStopPropagation></ig-field>
    <ig-field [control]="planForm.get('title')" label="Title"
              icon="title" igClickStopPropagation></ig-field>
    <ig-field [control]="planForm.get('content')" label="Content"
              icon="title" igClickStopPropagation></ig-field>

    <ig-button class="mt-2" cls="w-[120px]"
               (trigger)="createPlan(attraction, planMenuTrigger)">{{ plan ? 'Update' : 'Create' }}
    </ig-button>
  </div>
</mat-menu>
